import '../assets/NcGuestContent-27hnc8yQ.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcGuestContent"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { attrs: { "id": "guest-content-vue" } }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "4979e1a8"
);
const NcGuestContent = __component__.exports;
export {
  NcGuestContent as default
};
//# sourceMappingURL=NcGuestContent.mjs.map
